module.exports = __webpack_public_path__ + "img/40_38_051_490.dde8ce55.jpg";